import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MeasurementCommunicatorService {
  private measurementToolStatusSubject = new Subject<boolean>();

  public measurementToolStatus$ = this.measurementToolStatusSubject.asObservable();

  setMeasuremenToolStatus(toolStatus: boolean): void {
    this.measurementToolStatusSubject.next(toolStatus);
  }
}
